export class ApiError {
  constructor(
    public readonly StatusCode?: number,
    public readonly Message?: string,
    public readonly Details?: string | null,
  ) { }
}